const appData = require('../../assets/jsons/appData.json')

const GlobFunc = {
    install (Vue) {
      Vue.prototype.$appData  = appData         
      Vue.prototype.$showSpinner = GlobFunc.showSpinner
      Vue.prototype.$hideSpinner = GlobFunc.hideSpinner 
      Vue.prototype.$hideLoginSpinner = GlobFunc.hideLoginSpinner       
      Vue.prototype.$togglePrivPol = GlobFunc.togglePrivPol      
      Vue.prototype.$nl2br = GlobFunc.nl2br     
      Vue.prototype.$distance = GlobFunc.distance
      Vue.prototype.$isCertify = GlobFunc.isCertify
      Vue.prototype.$setDialogMsg = GlobFunc.setDialogMsg
      Vue.prototype.$startPosition = GlobFunc.startPosition     
      Vue.prototype.$create_UUID = GlobFunc.create_UUID
      Vue.prototype.$parseHike = GlobFunc.parseHike
      Vue.prototype.$parsePoint = GlobFunc.parsePoint
      Vue.prototype.$isRefreshActualCerify = GlobFunc.isRefreshActualCerify    
      Vue.prototype.$checkUserData  = GlobFunc.checkUserData         
      Vue.prototype.$openPage  = GlobFunc.openPage         
    },

    openPage(index){
        var url='';
        if (index==1) url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/Informacnc_povinnos_prevadzkovatea_2.pdf?alt=media&token=07b7d479-7d6b-4072-a5d4-80ef5f6f999e';
        if (index==2) url='https://firebasestorage.googleapis.com/v0/b/csavar-go.appspot.com/o/cookie_kezelesi_tudnivalok.pdf?alt=media&token=4f76604f-6a06-434f-963e-16720fe492bb';
        window.open(url, '_blank');
    },
    showSpinner(){
        var mySpinner = document.getElementById("spinner");
        mySpinner.style.width = "100%";
        mySpinner.style.display = 'block';        
    }, 
    hideSpinner(){
        var mySpinner = document.getElementById("spinner");
        mySpinner.style.display = 'none';        
    },  
    hideLoginSpinner(){
        var mySpinner = document.getElementById("loginspinner");
        mySpinner.style.display = 'none';        
    },        
    setDialogMsg(titleColor,titleMsg,bodyMsg){
        var msg = {
            "title": "<div class='w3-padding "+titleColor+" w3-xlarge'>"+titleMsg+"</div>",
            "body": "<div class='w3-padding'>"+bodyMsg+"</div>"
        };
        return msg;
    },
    togglePrivPol(){
        var item = document.getElementById("privPol");
        if (item.style.display === 'block') {
            item.style.display = 'none';
        } else {
            item.style.width = "100%";
            item.style.display = 'block';
        }           
    },

    nl2br (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    distance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            return dist;
        }
    },
    startPosition(pList){
        var sPosition={
            "lat": pList[0].lat,
            "lon": pList[0].lon
        }
        return sPosition;
    },

    isCertify(certify,geogo){
        if (geogo.type==1){
            if ((certify.sumtime>geogo.timeTour*3600) && (geogo.timeTour>0)) return false;
        } else{
            if ((certify.sumtime>geogo.timeBike*3600) && (geogo.timeBike>0)) return false;
        }
        for (var p in certify.points){
            if (certify.points[p]==0) return false;
        }
        return true;
    },
    create_UUID(){
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
    },
    parseHike(hike){
        var parsedHike=hike;
        parsedHike.ggpoint=parseInt(hike.ggpoint);
        parsedHike.status=parseInt(hike.status);
        parsedHike.mode=parseInt(hike.mode);
        parsedHike.ggpoint=parseInt(hike.ggpoint);
        parsedHike.prise=parseInt(hike.prise);
        parsedHike.price=parseFloat(hike.price);
        parsedHike.level=parseInt(hike.level);
        parsedHike.distance=parseFloat(hike.distance);
        parsedHike.timeTour=parseFloat(hike.timeTour);
        parsedHike.timeHike=parseFloat(hike.timeHike);
        parsedHike.timeRun=parseFloat(hike.timeRun);
        parsedHike.timeBike=parseFloat(hike.timeBike);
        return parsedHike;
    },
    parsePoint(point){
        var parsedPoint=point;
        parsedPoint.radius=parseInt(point.radius);
        parsedPoint.ordernum=parseInt(point.ordernum);
        if (parsedPoint.nextDist) parsedPoint.nextDist=parseFloat(point.nextDist);
        if (parsedPoint.prevDist) parsedPoint.prevDist=parseFloat(point.prevDist);        
        if (parsedPoint.nextLevel) parsedPoint.nextLevel=parseInt(point.nextLevel);
        if (parsedPoint.prevLevel) parsedPoint.prevLevel=parseInt(point.prevLevel);
        if (parsedPoint.type) parsedPoint.type=parseInt(point.type);
        if (parsedPoint.score) parsedPoint.score=parseInt(point.score);
        if (parsedPoint.required) parsedPoint.required=parseInt(point.required);

        return parsedPoint;
    },
    isRefreshActualCerify(cert){
        var actCert=this.$storage.get('actualCertify',null); 
        var ret=true;
        if (actCert!=null) {
            if ((actCert.id==cert.id) && 
                ((actCert.status>cert.status) || (actCert.enddate>cert.enddate))
               )
                ret=false;
        }       
        return ret;
    },
    checkUserData(user,price){
        var out=0;
        if (price>0) {
            if (user.address) {
                if (user.address.invName=='') out=1;
                if (user.address.invCode=='') out=1;
                if (user.address.invCity=='') out=1;
                if (user.address.invAdress=='') out=1;
                if (user.address.postName=='') out=1;
                if (user.address.postCode=='') out=1;
                if (user.address.postCity=='') out=1;
                if (user.address.postAdress=='') out=1;                
            } else out=1;
        }
        if (!((user.publicName) && (user.publicName!=''))) out=2;
        if (!((user.gender) && (user.gender!=''))) out=2;
        if (!((user.yearOfBirth) && (user.yearOfBirth!=''))) out=2;
        return out;
    }
  }
  
export default GlobFunc

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(GlobFunc)
}
  